<div class="container py-3">
  <div class="row">
    <div class="col-12 col-md-8 col-lg-6">
      <h5 translate>PUNCHOUT_CUSTOMER_CONFIG</h5>
      <p class="text-muted small" translate>PUNCHOUT_USER_BINDING_HINT</p>

      <div class="form-group">
        <label for="punchoutConfigSelect" translate>PUNCHOUT_CUSTOMER_CONFIG</label>
        <select
          id="punchoutConfigSelect"
          class="form-control"
          [(ngModel)]="selectedConfigId"
          (change)="apply()"
          [disabled]="loading"
        >
          <option [ngValue]="null">{{ 'PUNCHOUT_NONE_DEFAULT_REDIRECT' | translate }}</option>
          <option *ngFor="let config of availableConfigs" [ngValue]="config.id">
            {{ config.name }} ({{ config.format | uppercase }})
          </option>
        </select>
      </div>

      <div *ngIf="loading" class="text-muted small">
        <i class="fa fa-spinner fa-spin"></i>
        <span translate>LOADING</span>
      </div>
    </div>
  </div>
</div>
